import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

const PageLayout = ({ children, className = '' }) => (
  <div className={`min-h-screen bg-white ${className}`}>
    <Header />
    <main className="pt-28">{children}</main>
    <Footer />
  </div>
);

export default PageLayout;
